"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNAP_ID = void 0;
exports.SNAP_ID = "npm:@shapeshiftoss/metamask-snaps";
// export const SNAP_ID = "local:http://localhost:9000";
//# sourceMappingURL=common.js.map